const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckicon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 100 100",
    width: "200px",
    height: "200px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#E6EDB7"
    },
    cx: 50,
    cy: 50,
    r: 37
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#88AE45"
    },
    cx: 13,
    cy: 29,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F1BC19"
    },
    cx: 77,
    cy: 13,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F1BC19"
    },
    cx: 83,
    cy: 15,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#88AE45"
    },
    cx: 87,
    cy: 24,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FBCD59"
    },
    cx: 81,
    cy: 76,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FBCD59"
    },
    cx: 15,
    cy: 63,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#88AE45"
    },
    cx: 25,
    cy: 87,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 18.5,
    cy: 53.5,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F1BC19"
    },
    cx: 21,
    cy: 67,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 80,
    cy: 34,
    r: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#88AE45"
    },
    cx: 50,
    cy: 50,
    r: 23.958
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#472B29"
    },
    d: "M50,26.4c13.013,0,23.6,10.587,23.6,23.6S63.013,73.6,50,73.6S26.4,63.013,26.4,50   S36.987,26.4,50,26.4 M50,25c-13.807,0-25,11.193-25,25s11.193,25,25,25s25-11.193,25-25S63.807,25,50,25L50,25z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FDFCEF"
    },
    cx: 50,
    cy: 50,
    r: 19.5
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#472B29"
    },
    d: "M69.762,46.954c-0.043-0.273-0.298-0.46-0.571-0.418c-0.273,0.042-0.461,0.297-0.417,0.571   c0.931,5.976-1.054,12.082-5.309,16.334c-7.417,7.412-19.485,7.412-26.902,0c-7.417-7.411-7.417-19.471,0-26.883   c7.417-7.411,19.485-7.411,26.902,0c0.778,0.778,1.493,1.642,2.186,2.641c0.158,0.227,0.469,0.284,0.697,0.126   c0.225-0.155,0.283-0.468,0.126-0.696c-0.728-1.049-1.481-1.958-2.302-2.778c-7.807-7.801-20.51-7.802-28.318,0   c-7.807,7.802-7.807,20.496,0,28.298c7.807,7.801,20.51,7.802,28.318,0C68.653,59.672,70.743,53.244,69.762,46.954z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#472B29"
    },
    d: "M67.569,42.796c0.105,0.256,0.398,0.378,0.653,0.273c0.254-0.104,0.378-0.396,0.272-0.652   c-0.315-0.766-0.609-1.395-0.926-1.977c-0.132-0.243-0.436-0.332-0.679-0.2c-0.043,0.023-0.082,0.053-0.115,0.086   c-0.153,0.153-0.194,0.393-0.086,0.593C66.989,41.468,67.269,42.065,67.569,42.796z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#88AE45"
    },
    d: "M41,48.375c-0.434,0-0.842,0.169-1.149,0.476c-0.307,0.307-0.476,0.715-0.476,1.149   s0.169,0.842,0.476,1.149l7,7c0.307,0.307,0.715,0.476,1.149,0.476V59l0.031-0.375c0.445-0.009,0.869-0.201,1.167-0.526l11-12   c0.293-0.32,0.444-0.735,0.426-1.169c-0.019-0.434-0.206-0.833-0.525-1.127c-0.321-0.293-0.728-0.45-1.169-0.426   c-0.433,0.019-0.833,0.205-1.126,0.525l-9.854,10.749l-5.8-5.8C41.842,48.544,41.434,48.375,41,48.375z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#472B29"
    },
    d: "M59,43.75L59,43.75c0.313,0,0.613,0.117,0.845,0.329c0.246,0.226,0.389,0.533,0.404,0.867   c0.014,0.334-0.102,0.653-0.328,0.899l-11,12c-0.229,0.25-0.555,0.398-0.921,0.405c-0.334,0-0.648-0.13-0.884-0.366l-7-7   C39.88,50.648,39.75,50.334,39.75,50s0.13-0.648,0.367-0.884C40.352,48.88,40.666,48.75,41,48.75s0.648,0.13,0.884,0.366   l5.523,5.523l0.554,0.554l0.529-0.577l9.589-10.461C58.318,43.894,58.645,43.75,59,43.75 M59,43c-0.541,0-1.08,0.218-1.474,0.649   l-9.589,10.46l-5.523-5.523C42.024,48.195,41.512,48,41,48s-1.024,0.195-1.414,0.586c-0.781,0.781-0.781,2.047,0,2.828l7,7   C46.961,58.79,47.47,59,48,59c0.015,0,0.029,0,0.043,0c0.545-0.012,1.062-0.246,1.431-0.648l11-12   c0.747-0.814,0.691-2.08-0.123-2.826C59.967,43.174,59.483,43,59,43L59,43z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckicon);
export default __webpack_public_path__ + "static/media/checkicon.bae2b72f0ebf485e3e4b5bab1b51fa60.svg";
export { ForwardRef as ReactComponent };